import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconRocketSvg } from "./IconRocketSvg.mjs";
const IconRocket = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconRocketSvg, ...iconProps });
};
export {
  IconRocket
};
